import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import { computed } from 'vue';

import FieldHistoryBtn from 'SharedComponents/Fields/FieldHistoryBtn.vue';
import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
  useBaseFieldProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFieldParams from 'SharedComponents/Fields/composables/useFieldParams';
import { useTooltip } from 'SharedComponents/Fields/composables/useFieldTooltip';
import Tooltip from 'SharedComponents/ui/Tooltip.vue';
import useValidation, { ValidationRule } from 'SharedDir/common/composables/useValidation';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { FieldValue, NumberFieldParams } from 'SharedDir/declarations/fields';

type TextFieldProps = ValuedFieldProps &
  PropValue<FieldValue<null | number>> & {
    params: NumberFieldParams;
    suffix: { shortName: string } | null;
    regexp?: string;
    regexpMessage?: string;
  };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'NumberField' },
  __name: 'NumberField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    params: {},
    suffix: {},
    regexp: {},
    regexpMessage: {}
  }, {
  ...defaultValuedProps,
  suffix: () => ({ shortName: '' }),
}),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const { LessThenOrEqual, GreaterThenOrEqual, CheckRegex, IsInteger } = useValidation();

const { innerValue, emitValue } = useValue(props, emit);

const customRules = computed(() => {
  const rules: Array<ValidationRule> = [];
  if (props.params.max) {
    rules.push(LessThenOrEqual(props.params.max));
  }
  if (props.params.min) {
    rules.push(GreaterThenOrEqual(props.params.min));
  }
  if (!props.params.isFloat) {
    rules.push(IsInteger());
  }
  if (props.regexp) {
    rules.push(CheckRegex(props.regexp, props.regexpMessage));
  }
  return rules;
});

const { params, validationRules } = useFieldParams<NumberFieldParams>(props, { customRules });

const { validationErrorStatus, hasHistory, revealHistory } = useBaseFieldProps(props, emit);

const tooltip = useTooltip(props);

const suffixCheck = computed(() => (props.suffix?.shortName ? props.suffix.shortName : ''));

return (_ctx: any,_cache: any) => {
  const _component_s_input = _resolveComponent("s-input")!

  return (_openBlock(), _createBlock(_component_s_input, {
    ref: "input",
    modelValue: _unref(innerValue).value,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).value) = $event)),
      _unref(emitValue)
    ],
    modelModifiers: { number: true },
    clearable: "",
    outlined: "",
    dense: "",
    type: "number",
    "hide-bottom-space": "",
    class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
    label: _ctx.label,
    readonly: _ctx.readonly,
    required: _ctx.required,
    disable: _ctx.disable,
    placeholder: _unref(params).placeholder ? _unref(params).placeholder : '',
    rules: _unref(validationRules),
    error: _unref(validationErrorStatus),
    "error-message": _ctx.errorMessage,
    suffix: suffixCheck.value
  }, _createSlots({ _: 2 }, [
    (_unref(tooltip) || (_ctx.showHistory && _unref(hasHistory)))
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            (_unref(tooltip))
              ? (_openBlock(), _createBlock(Tooltip, {
                  key: 0,
                  text: _unref(tooltip)
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            (_ctx.showHistory && _unref(hasHistory))
              ? (_openBlock(), _createBlock(FieldHistoryBtn, {
                  key: 1,
                  history: _ctx.history,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(revealHistory)(_ctx.label)))
                }, null, 8, ["history"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "class", "label", "readonly", "required", "disable", "placeholder", "rules", "error", "error-message", "suffix", "onUpdate:modelValue"]))
}
}

})